import {
  appendLogicalFlag,
  SPECIAL_DEALS_LOGICAL_FLAG,
} from '@home/pages/studio/home/utils/logicalFlag';

export { SPECIAL_DEALS_LOGICAL_FLAG };

/**
 * 开关打开且节点启用打标时，在已有 logical_flag 上追加 show_special_deals。
 * 不改动 dashboard Service，由 home 包装层 / beforeRequest 调用。
 */
export function applySpecialDealsFlag<T>(
  params: T,
  reqData: { specialDealsEnabled?: boolean; } | undefined,
  appendEnabled?: boolean,
): T {
  if (params === false || params === null || params === undefined) {
    return params;
  }
  if (
    !appendEnabled ||
    !reqData?.specialDealsEnabled ||
    typeof params !== 'object'
  ) {
    return params;
  }
  const current = (params as { logical_flag?: string; }).logical_flag;
  return {
    ...(params as Record<string, unknown>),
    logical_flag: appendLogicalFlag(current, SPECIAL_DEALS_LOGICAL_FLAG),
  } as T;
}

/** 打标开启时把 specialDealsEnabled 并入 trackData，确保切换开关会重请求 */
export function mergeSpecialDealsTrackData(
  trackData: string[] | undefined,
  appendEnabled?: boolean,
): string[] {
  const base = Array.isArray(trackData) ? [...trackData] : [];
  if (appendEnabled && !base.includes('specialDealsEnabled')) {
    base.push('specialDealsEnabled');
  }
  return base;
}
